import axios from 'axios'
import nprogress from 'nprogress'
import { Message } from 'element-ui'

import router from '../router'
import config from '../config'

nprogress.configure({
  showSpinner: false
})

function buildFormData(data) {
  const formData = new FormData()
  Object.keys(data).forEach(key => {
    formData.append(key, data[key])
  })
  return formData
}

let reqs = 0
function reqEnd() {
  if (!--reqs) {
    nprogress.done(true)
  }
}

function http(method, url, data, options) {
  return new Promise((resolve, reject) => {
    if (method == 'POST') {
      data = buildFormData(data)
    }

    nprogress.start()
    reqs += 1

    axios({
      baseURL: config.apiBase,
      url,
      method,
      data,
      params: method == 'GET' ? data : undefined,
      withCredentials: true,
      ...options
    }).then(res => {
      if (res.status != 200) {
        Message.error('連接失敗')
        reject(res)
        return
      }

      const resData = res.data
      if (resData.error != 0) {
        if (resData.error == 101) {
          localStorage.removeItem('user')
          router.replace({ name: 'Login', query: { url: /\/login/.test(location.hash) ? undefined : location.hash.replace('#', '') } })
        } else {
          Message.error(resData.error_msg || '連接錯誤')
        }
        reject(resData)
        return
      }

      if (resData.data) {
        resolve(resData.data)
        return
      }

      resolve(resData)
    }).catch(err => {
      Message.error('網絡錯誤')
      reject(err)
    }).finally(() => {
      reqEnd()
    })
  })
}

http.post = http.bind(http, 'POST')
http.get = http.bind(http, 'GET')

export default http
